// Copyright (C) 2017-2023 Smart code 203358507

const StreamingServerWarning = require('./StreamingServerWarning');

module.exports = StreamingServerWarning;
